import type { Dealer, IDxgVehicle } from '@makemydeal/dr-shared-types';

export const validateDeal = (
    vehicle: IDxgVehicle | undefined,
    isConsumerValid: boolean | undefined,
    dealer: Partial<Dealer> | undefined
) => {
    const isVehicleValid = isValidVehicle(vehicle);
    const isDealValid = !!(dealer?.dealerId && isVehicleValid && isConsumerValid);

    return {
        isDealValid,
        isVehicleValid
    };
};

const isValidVehicle = (vehicle: IDxgVehicle | undefined): boolean => {
    if (!vehicle) {
        return false;
    }

    return !!(
        vehicle.odometerMileage &&
        vehicle.priceCostDetails &&
        vehicle.priceCostDetails.originalMsrp &&
        vehicle.priceCostDetails.retailPrice
    );
};
